var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobbliDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_196_18",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 24,
    width: 92,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 24.7002H19.5V106.6H110.5V24.7002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_196_18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_196_18",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 24,
    width: 92,
    height: 83
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 24.7002H19.5V106.6H110.5V24.7002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_196_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.924 61.3645C109.924 86.3438 89.8082 106.6 65.001 106.6C40.194 106.6 20.0779 86.3438 20.0779 61.3645C20.0779 56.3696 24.1021 52.3174 29.0625 52.3174C34.0229 52.3174 38.0471 56.3696 38.0471 61.3645C38.0471 76.3541 50.1149 88.5056 65.001 88.5056C79.8869 88.5056 91.9552 76.3541 91.9552 61.3645C91.9552 56.3696 95.9789 52.3174 100.939 52.3174C105.9 52.3174 109.924 56.3696 109.924 61.3645Z",
    fill: "#10101B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94 43.9557C106.221 43.9557 110.502 39.6451 110.502 34.3278C110.502 29.0103 106.221 24.6997 100.94 24.6997C95.6595 24.6997 91.3789 29.0103 91.3789 34.3278C91.3789 39.6451 95.6595 43.9557 100.94 43.9557Z",
    fill: "#10101B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0616 43.9557C34.3422 43.9557 38.623 39.6451 38.623 34.3277C38.623 29.0103 34.3422 24.6997 29.0616 24.6997C23.7808 24.6997 19.5 29.0103 19.5 34.3277C19.5 39.6451 23.7808 43.9557 29.0616 43.9557Z",
    fill: "#10101B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 81.9,
    fill: "white",
    transform: "translate(19.5 24.7002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobbliDefaultIcon);
export default __webpack_public_path__ + "static/media/jobbli-default-icon.82c6d95a9c63104e5771b110b60331fe.svg";
export { ForwardRef as ReactComponent };